module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"confirmLeave":"Really discard changes?"},"de":{"confirmLeave":"Änderungen wirklich verwerfen?"},"fr":{"confirmLeave":"Souhaitez-vous réellement abandonner les modifications ?"}}')
  delete Component.options._Ctor
}
